/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
/* eslint-disable new-cap */
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import dayjs from 'dayjs';
import toDataUrl from 'utils/toDataUrl';

const logo = 'data:image/png;base64,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';

const isEvaluationWithLeg = (exercise) => {
  const exercisesWithoutLeg = ['Push Up', 'Recline Pull', 'Rotation withour Pivot'];
  return !exercisesWithoutLeg.includes(exercise);
};

const createHeader = (headers) => {
  const result = [];
  headers.forEach((header, i) => {
    result.push({
      id: header,
      name: header,
      prompt: header,
      width: i === 0 ? 60 : 25,
      align: 'center',
      padding: 0,
    });
  });
  return result;
};
const createEvaluationHeader = (headers) => {
  const result = [];
  headers.forEach((header, i) => {
    result.push({
      id: header,
      name: header,
      prompt: header,
      width: i === 0 ? 130 : 50,
      align: i === 0 ? 'left' : 'center',
      padding: 0,
    });
  });
  return result;
};

const generateRoutinesData = (data, lang) => {
  const result = [];

  data.forEach(async (exercise) => {
    const obj = {
      exercise: exercise.id_exercise.name[lang],
      set1: `${exercise.sets[0].load}${exercise.sets[0].typeWeight}/${exercise.sets[0].reps}reps`,
      set2: `${exercise.sets[1].load}${exercise.sets[1].typeWeight}/${exercise.sets[1].reps}reps`,
      set3: `${exercise.sets[2].load}${exercise.sets[2].typeWeight}/${exercise.sets[2].reps}reps`,
      set4: `${exercise.sets[3].load}${exercise.sets[3].typeWeight}/${exercise.sets[3].reps}reps`,
    };
    result.push(obj);
  });
  console.log('data', result);
  return result;
};

const generateEvaluationsData = (data, lang) => {
  const result = [];

  data.forEach((d) => {
    const obj = {
      weakMuscle: d.default_muscle[lang].join('\n'),
      observation: d.defaultMsg[lang],
    };
    result.push(obj);
  });
  console.log('data', result);
  return result;
};

// JOSÉ ESTUVO AQUÍ

const generateReport = (report, lang) => {
  let doc = new jsPDF('l', 'mm', 'a4');
  let docTitle = 'ReporteDeEjercios';

  doc.setFontSize(14);
  doc.addImage(logo, 'JPEG', 4, 4, 25, 8);
  /*   doc.text(220, 50, 'Routine Report');
  doc.text(220, 90, report.workout_name); */

  doc.text(35, 10, `${report.id_client.name}'s routine`);
  doc.text(100, 10, `Trainer: ${report.id_trainer.name}`);
  if (report.date !== null) doc.text(200, 10, `Starts on ${dayjs(report.date).format('MM/DD/YYYY')}`);

  doc.setProperties({
    title: docTitle,
    subject: docTitle,
    author: report.id_trainer.name,
    keywords: 'Reportes',
  });

  doc.setFont('Times-Roman');
  const reportSessionsFormated = report.sessions.map((session) => {
    let arrayObjExercises = [];
    // eslint-disable-next-line no-restricted-syntax
    for (let i = 0; i < session.exercises.length; i += 1) {
      let objExercise = {};
      let exercise = session.exercises[i];
      if (exercise.id_exercise?.images !== undefined || exercise.id_exercise?.images !== 'undefined') {
        objExercise.img = exercise.id_exercise?.images[0] ? exercise.id_exercise?.images[0] : '';
      }
      objExercise.weekday = `Week ${session.week} Day ${session.day}`;
      if (exercise.id_exercise?.name !== undefined || exercise.id_exercise?.name !== 'undefined') {
        objExercise.name = exercise.id_exercise.name[lang];
      }
      objExercise.set1 = (exercise.sets[0].reps === 0 || exercise.sets[0].load === 0) ? '' : `Load: ${exercise.sets[0].load}${exercise.sets[0].typeWeight} / Reps: ${exercise.sets[0].reps}`;
      objExercise.set2 = (exercise.sets[1].reps === 0 || exercise.sets[1].load === 0) ? '' : `Load: ${exercise.sets[1].load}${exercise.sets[1].typeWeight} / Reps: ${exercise.sets[1].reps}`;
      objExercise.set3 = (exercise.sets[2].reps === 0 || exercise.sets[2].load === 0) ? '' : `Load: ${exercise.sets[2].load}${exercise.sets[2].typeWeight} / Reps: ${exercise.sets[2].reps}`;
      objExercise.set4 = (exercise.sets[3].reps === 0 || exercise.sets[3].load === 0) ? '' : `Load: ${exercise.sets[3].load}${exercise.sets[3].typeWeight} / Reps: ${exercise.sets[3].reps}`;
      objExercise.set5 = (exercise.sets[4].reps === 0 || exercise.sets[4].load === 0) ? '' : `Load: ${exercise.sets[4].load}${exercise.sets[4].typeWeight} / Reps: ${exercise.sets[4].reps}`;
      arrayObjExercises.push(objExercise);
    }
    return arrayObjExercises;
  });

  reportSessionsFormated.map((arrayObjExercises) => (
    // Aqui le pueden agregar un nombre a la tabla/Sesión (No sé cómo pero debería ser aquí)
    // Documentación de jspdf-autotable: https://www.npmjs.com/package/jspdf-autotable
    doc.autoTable({
      body: arrayObjExercises,
      didDrawCell: (data) => {
        console.log(data);
        if (data.section === 'body' && data.column.index === 0) {
          const base64Img = data.row.raw.img;
          // const base64Img = 'https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/female-athlete-practicing-side-plank-at-home-royalty-free-image-1632260664.jpg?crop=0.668xw:1.00xh;0.102xw,0&resize=640:*';
          doc.addImage(base64Img, 'JPEG', data.cell.x + 2, data.cell.y + 2, 10, 10);
        }
      },
      columns: [
        { header: 'Image' },
        { header: 'Week / Day', dataKey: 'weekday' },
        { header: 'Name', dataKey: 'name' },
        { header: 'Set 1', dataKey: 'set1' },
        { header: 'Set 2', dataKey: 'set2' },
        { header: 'Set 3', dataKey: 'set3' },
        { header: 'Set 4', dataKey: 'set4' },
        { header: 'Set 5', dataKey: 'set5' },

      ],
    })
  ));
  doc.save('Reporte.pdf');
};

// END JOSÉ ESTUVO AQUÍ

const generateBasicReport = (report, lang) => {
  let doc = new jsPDF('l', 'mm', 'a4');
  let docTitle = 'ReporteDeEjercios';

  doc.setFontSize(14);
  doc.addImage(logo, 'JPEG', 4, 4, 25, 8);
  /*   doc.text(220, 50, 'Routine Report');
  doc.text(220, 90, report.workout_name); */

  doc.text(35, 10, `${report.id_client.name}'s routine`);
  doc.text(100, 10, `Trainer: ${report.id_trainer.name}`);
  if (report.date !== null) doc.text(200, 10, `Starts on ${dayjs(report.date).format('MM/DD/YYYY')}`);

  doc.setProperties({
    title: docTitle,
    subject: docTitle,
    author: report.id_trainer.name,
    keywords: 'Reportes',
  });

  doc.setFont('Times-Roman');
  const reportSessionsFormated = report.sessions.map((session) => {
    let arrayObjExercises = [];
    // eslint-disable-next-line no-restricted-syntax
    for (let i = 0; i < session.exercises.length; i += 1) {
      let objExercise = {};
      let exercise = session.exercises[i];

      objExercise.weekday = `Week ${session.week} Day ${session.day}`;
      if (exercise.id_exercise?.name !== undefined || exercise.id_exercise?.name !== 'undefined') {
        objExercise.name = exercise.id_exercise.name[lang];
      }
      objExercise.set1 = (exercise.sets[0].reps === 0 || exercise.sets[0].load === 0) ? '' : `Load: ${exercise.sets[0].load}${exercise.sets[0].typeWeight} / Reps: ${exercise.sets[0].reps}`;
      objExercise.set2 = (exercise.sets[1].reps === 0 || exercise.sets[1].load === 0) ? '' : `Load: ${exercise.sets[1].load}${exercise.sets[1].typeWeight} / Reps: ${exercise.sets[1].reps}`;
      objExercise.set3 = (exercise.sets[2].reps === 0 || exercise.sets[2].load === 0) ? '' : `Load: ${exercise.sets[2].load}${exercise.sets[2].typeWeight} / Reps: ${exercise.sets[2].reps}`;
      objExercise.set4 = (exercise.sets[3].reps === 0 || exercise.sets[3].load === 0) ? '' : `Load: ${exercise.sets[3].load}${exercise.sets[3].typeWeight} / Reps: ${exercise.sets[3].reps}`;
      objExercise.set5 = (exercise.sets[4].reps === 0 || exercise.sets[4].load === 0) ? '' : `Load: ${exercise.sets[4].load}${exercise.sets[4].typeWeight} / Reps: ${exercise.sets[4].reps}`;
      arrayObjExercises.push(objExercise);
    }
    return arrayObjExercises;
  });

  reportSessionsFormated.map((arrayObjExercises) => (
    // Aqui le pueden agregar un nombre a la tabla/Sesión (No sé cómo pero debería ser aquí)
    // Documentación de jspdf-autotable: https://www.npmjs.com/package/jspdf-autotable
    doc.autoTable({
      body: arrayObjExercises,
      columns: [
        { header: 'Week / Day', dataKey: 'weekday' },
        { header: 'Name', dataKey: 'name' },
        { header: 'Set 1', dataKey: 'set1' },
        { header: 'Set 2', dataKey: 'set2' },
        { header: 'Set 3', dataKey: 'set3' },
        { header: 'Set 4', dataKey: 'set4' },
        { header: 'Set 5', dataKey: 'set5' },
      ],
    })
  ));
  doc.save('ReporteBasico.pdf');
};

// const generateBasicReport = (report, lang) => {
//   const doc = new jsPDF('l', 'mm', 'a4');
//   let distance = 0;
//   const headers = createHeader([
//     'exercise',
//     'set1',
//     'set2',
//     'set3',
//     'set4',
//   ]);
//   console.log('basic report');

//   // doc.setFontSize(30);
//   doc.addImage(logo, 'JPEG', 4, 4, 25, 8);
//   doc.text(35, 10, `${report.id_client.name}'s routine`);
//   doc.text(100, 10, report.workout_name[lang]);
//   doc.text(170, 10, `Trainer: ${report.id_trainer.name}`);
//   if (report.date !== null){
// doc.text(220, 10, `Starts on ${dayjs(report.date).format('MM/DD/YYYY')}`);
// }

//   report.sessions
//     .sort((sessionA, sessionB) => sessionA.number - sessionB.number)
//     .forEach((session) => {
//       console.log('session data', session);
//       const exerciseDistance = session.exercises.length * 8;
//       doc.setFontSize(12);
//       if (session.number === 3 || session.number === 5) distance = 0;
//       if (session.number <= 2) {
//         doc.text(
//           30,
//           23 + distance,
//           `Session ${session.number}`,
//         );
//         doc.table(
//           10,
//           25 + distance,
//           generateRoutinesData(session.exercises, lang),
//           headers,
//           { fontSize: 6, margins: '1' },
//         );
//       }

//       if (session.number > 2 && session.number <= 4) {
//         doc.text(
//           170,
//           23 + distance,
//           `Session ${session.number}`,
//         );
//         doc.table(
//           150,
//           25 + distance,
//           generateRoutinesData(session.exercises, lang),
//           headers,
//           { fontSize: 6, margins: '1' },
//         );
//       }
//       if (session.number >= 5) {
//         doc.addPage('a4', 'l');
//         doc.addImage(logo, 'JPEG', 4, 4, 25, 8);
//         distance = 0;
//         doc.text(
//           15,
//           23 + distance,
//           `Session ${session.number}`,
//         );
//         doc.table(
//           13,
//           25 + distance,
//           generateRoutinesData(session.exercises, lang),
//           headers,
//           { fontSize: 6, margins: '1' },
//         );
//       }

//       console.log('exercise distance', exerciseDistance);
//       console.log('total distance', distance);

//       distance += exerciseDistance + 20;
//     });

//   doc.save(`${report.id_client.name}_routine.pdf`);
// };
const generateMediumReport = async (report) => {
  const doc = new jsPDF('p', 'pt');
  let distance = 0;

  console.log('Medium report');
  doc.setFontSize(28);
  doc.addImage(logo, 'JPEG', 20, 20, 150, 40);
  doc.text(220, 50, 'Routine Report');
  doc.text(220, 90, report.workout_name);

  doc.setFontSize(18);
  doc.text(20, 120, `Hello ${report.id_client.name}`);
  doc.setFontSize(16);
  doc.text(20, 140, `Your trainer is ${report.id_trainer.name}`);
  if (report.date !== null) doc.text(20, 160, `Routine starts on ${dayjs(report.date).format('MM/DD/YYYY')}`);

  // const imgResponse = await toDataUrl(report.sessions[0].exercises[0].id_exercise.images[0]);
  // console.log(imgResponse);
  // if (typeof imgResponse !== 'undefined') {
  //   doc.addImage(
  //     imgResponse,
  //     'JPEG',
  //     300,
  //     200,
  //     230,
  //     120,
  //   );
  // }
  report.sessions
    .sort((sessionA, sessionB) => sessionA.number - sessionB.number)
    .forEach((session) => {
      let exerciseDistance = session.exercises.length * 20;
      session.exercises.forEach(async (exercise) => {
        let setDistance = 0;
        let img = '';
        console.log(exercise);
        if (typeof exercise.id_exercise.images[0] !== 'undefined' || exercise.id_exercise.images[0] !== null) {
          console.log('entra');
          img = await toDataUrl(exercise.id_exercise.images[0]);
        }
        console.log('img efsd', img);
        doc.addImage(
          img,
          'JPEG',
          300,
          200 + distance,
          300,
          100,
          'alias1',
          'SLOW',
        );
        doc.text(
          220,
          session.number >= 3 ? 100 + distance : 180 + distance,
          `Day ${session.number}`,
        );
        doc.text(exercise.id_exercise.name, 20, 200 + distance);

        exercise.sets.forEach((set) => {
          doc.text(
            `Set ${set.set_number} - ${set.load}${set.typeWeight}/${set.reps}reps`,
            50,
            220 + setDistance + distance,
          );

          setDistance += 30;
        });
        distance += exerciseDistance + 150;
        // exerciseDistance += 150;
      });
      if (session.number === 3) {
        doc.addPage();
        doc.addImage(logo, 'JPEG', 20, 20, 150, 40);
        distance = 0;
      }
      // doc.table(
      //   20,
      //   session.number >= 5 ? 180 + distance : 260 + distance,
      //   generateRoutinesData(session.exercises),
      //   headers,
      //   // { autoSize: true },
      // );

      distance += exerciseDistance + 120;
    });
  doc.save(`${report.id_client.name}_routine.pdf`);
};

const generateFullReport = (report) => {
  const doc = new jsPDF('p', 'pt');
  let distance = 0;
  const headers = createHeader([
    'exercise',
    'set1',
    'set2',
    'set3',
    'set4',
  ]);

  doc.setFontSize(30);
  doc.addImage(logo, 'JPEG', 20, 20, 150, 40);
  doc.text(220, 50, 'Routine Report');
  doc.text(220, 100, report.id_client.name);

  doc.setFontSize(16);
  doc.text(20, 120, `Hello ${report.id_client}`);
  doc.text(20, 140, `Your trainer is ${report.id_trainer.name}`);
  if (report.date !== null) doc.text(20, 160, `Routine starts on ${dayjs(report.date).format('MM/DD/YYYY')}`);

  report.sessions.forEach((session) => {
    const exerciseDistance = session.exercises.length * 20;
    doc.text(220, 180 + distance, `Day ${session.number}`);
    doc.table(
      20,
      190 + distance,
      generateRoutinesData(session.exercises),
      headers,
      // { autoSize: true },
    );

    distance += exerciseDistance + 20;
  });

  console.log('Full report');
  console.log(report);
  doc.save(`${report.id_client}_routine.pdf`);
};

const generateEvaluationPDF = (evaluations, client, lang) => {
  const doc = new jsPDF('l', 'mm', 'a4');
  // let distance = 0;
  let evaluationNumber = 0;
  let side = 'left';
  const headers = createEvaluationHeader([
    'observation',
    'weakMuscle',
  ]);

  doc.addImage(logo, 'JPEG', 4, 4, 25, 8);
  doc.setFontSize(20);
  doc.text(110, 10, lang === 'en' ? `${client}'s evaluation` : `Evaluación de ${client}`);

  evaluations.forEach((evaluation) => {
    if (evaluationNumber % 2 === 0 && evaluationNumber !== 0) {
      // distance = 0;
      doc.addPage();
      doc.addImage(logo, 'JPEG', 4, 4, 25, 8);
    }
    doc.setFontSize(12);
    doc.text(
      evaluation.exercise,
      side === 'left' ? 10 : 150,
      20,
    );
    if (isEvaluationWithLeg(evaluation.exercise)) {
      doc.setFontSize(9);
      doc.text(
        lang === 'en'
          ? `Dominant leg: ${evaluation.dominant_leg} - Succesful reps in left: ${evaluation.succesfulMovements.leftLeg}, in right ${evaluation.succesfulMovements.rightLeg}`
          : `Tu pierna dominante en este ejercicio es la ${evaluation.dominant_leg}`,
        side === 'left' ? 10 : 150,
        25,
      );
    }
    doc.table(
      side === 'left' ? 10 : 150,
      isEvaluationWithLeg(evaluation.exercise) ? 30 : 25,
      generateEvaluationsData(evaluation.notes, lang),
      headers,
      { fontSize: 8 },
    );

    // distance += miniSpace + 35;
    evaluationNumber += 1;
    side = side === 'left' ? 'right' : 'left';
  });
  doc.save(`${client}'s_evaluation.pdf`);
};

// Generate excersises report in pdf

export {
  generateReport,
  generateBasicReport,
  generateMediumReport,
  generateFullReport,
  generateEvaluationPDF,
};
